import { useRef, useState } from "react";
import { CheckCircle2, Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

const fmt = (s) => (s ? new Date(s).toLocaleString("es-AR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: "America/Argentina/Buenos_Aires" }) : "");

/** El pasajero sube la foto o PDF del comprobante de su transferencia. */
export const ReceiptUpload = ({ code, t, receiptAt, onDone }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const send = async (file) => {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) return toast.error("El archivo tiene que pesar menos de 10 MB");
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      await api.post(`/tickets/${encodeURIComponent(code)}/receipt`, fd, { params: { t } });
      toast.success("¡Comprobante enviado! Te avisamos cuando confirmemos el pasaje");
      onDone();
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); if (input.current) input.current.value = ""; }
  };
  return (
    <div data-testid="receipt-upload" className="mt-3 rounded-2xl bg-white p-4 text-sm text-[var(--ink)]">
      {receiptAt
        ? <p data-testid="receipt-sent" className="flex items-start gap-2"><CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[var(--forest)]" /><span>Recibimos tu comprobante ({fmt(receiptAt)}). Lo estamos revisando: tus butacas quedan guardadas y te avisamos por email cuando el pasaje esté confirmado.</span></p>
        : <p>¿Ya transferiste? Subí la foto o el PDF del comprobante y guardamos tus butacas mientras lo revisamos.</p>}
      <input ref={input} type="file" accept="image/*,application/pdf" className="hidden" data-testid="receipt-file-input" onChange={(e) => send(e.target.files?.[0])} />
      <button type="button" onClick={() => input.current?.click()} disabled={busy} data-testid="receipt-upload-button"
        className="mt-3 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[var(--forest)] font-bold text-white transition-colors hover:bg-[var(--forest-2)] disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {receiptAt ? "Enviar otro comprobante" : "Subir comprobante"}
      </button>
    </div>
  );
};
